export const DeviceImage = ({ className = "h-64", float = true }) => (
  <div className={`device-wrap ${className}`} data-testid="device-image">
    <div className="device-glow" aria-hidden="true" />
    <img
      src="/device.webp"
      alt="VoiceGuard hardware authentication device with cyan fingerprint scanner"
      className={`relative h-full w-auto select-none ${float ? "device-float" : ""}`}
      draggable="false"
    />
  </div>
);
